export default {
  path: '/share',
  component: resolve => require(['@/components/common/ViewTemplate'], resolve),
  children: [
    {
      path: 'certificate',
      component: resolve => require(['@/components/share/CertificateImage'], resolve),
    },
  ],
};



// WEBPACK FOOTER //
// ./src/router/modules/share/index.js